import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';


@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent implements OnInit {
  @Input() items: { link: string; title: string; subTitle: string }[] = [];
  title: string = '';

  constructor(public router: Router) {
  }

  ngOnInit(): void {
    this.updateTitle();
    this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.updateTitle();
    });
  }

  updateTitle(): void {
    this.title = this.items.find(({link}) => link === this.router.url)?.title || '';
  }
}
